<mbs-modal
  [isCustomModal]="true"
  [loading]="loading">
  <ng-container modal-header>
    <div
      *ngIf="baseModal?.data?.simpleMode"
      [attr.data-e2e]="elementsSelector.name.simpleModeTitle">
      {{ 'shared:allowOfflineEdit.simpleModalTitle' | i18next: { format: 'capitalize' } }}
    </div>

    <div
      *ngIf="!baseModal?.data?.simpleMode"
      [attr.data-e2e]="elementsSelector.name.notSimpleModeTitle"
      class="header-container">
      <img
        src="assets/images/other/allowOfflineEdit.svg"
        style="border-radius: 6px 6px 0 0"
        width="500"
        height="240" />
      <div class="header-container-close">
        <mbs-button
          (click)="tryLaterClickHandler()"
          [isCtrl]="true"
          [size]="MbsSize.lg"
          icon="fa fa-close text-xl"
          type="dark"
          aria-label="Close"
          data-dismiss="modal"></mbs-button>
      </div>
    </div>
  </ng-container>

  <ng-container modal-body>
    <h3
      *ngIf="!baseModal?.data?.simpleMode"
      [attr.data-e2e]="elementsSelector.name.notSimpleModeContent"
      class="text-center">
      <mbs-tag
        [clickable]="false"
        [closable]="false"
        [active]="true"
        [noBorder]="true"
        [class]="'background-dark text-uppercase border-radius-sm-important mr-1'"
        [size]="MbsSize.sm">
        {{ 'shared:beta' | i18next }}
      </mbs-tag>

      {{ 'shared:allowOfflineEdit.backupPlanManagement' | i18next: { format: 'capitalize' } }} <br />
      <span class="ml-3">{{ 'shared:allowOfflineEdit.offlineComputer' | i18next }}</span>
    </h3>
    <span class="d-block mb-2">
      {{ 'shared:allowOfflineEdit.modalText' | i18next: { format: 'capitalize' } }}
    </span>
    <span class="d-block mb-3">
      {{ 'shared:allowOfflineEdit.modalTextNote' | i18next: { format: 'capitalize' } }}
    </span>

    <mbs-alert
      class="mb-0"
      [type]="alertType.warning"
      [icon]="true">
      {{ 'shared:allowOfflineEdit.agentVersion' | i18next }}
    </mbs-alert>
  </ng-container>

  <ng-container modalFooter>
    <div
      *ngIf="baseModal?.data?.simpleMode"
      [attr.data-e2e]="elementsSelector.name.simpleModeButtons">
      <mbs-button
        type="primary"
        class="mr-3"
        (click)="allowClickHandler()">
        {{ 'shared:buttons.allow' | i18next: { format: 'title' } }}
      </mbs-button>
      <mbs-button
        type="secondary"
        (click)="tryLaterClickHandler()">
        {{ 'shared:buttons.cancel' | i18next: { format: 'title' } }}
      </mbs-button>
    </div>

    <div
      *ngIf="!baseModal?.data?.simpleMode"
      [attr.data-e2e]="elementsSelector.name.notSimpleModeButtons">
      <mbs-button
        type="secondary"
        class="mr-3"
        (click)="tryLaterClickHandler()">
        {{ 'shared:allowOfflineEdit.tryLater' | i18next: { format: 'title' } }}
      </mbs-button>
      <mbs-button
        type="primary"
        (click)="allowClickHandler()">
        {{ 'shared:allowOfflineEdit.allow' | i18next: { format: 'title' } }}
      </mbs-button>
    </div>
  </ng-container>
</mbs-modal>
